module.exports = __webpack_public_path__ + "static/thumbnail-16a70559ab07712f83d3ce412dfbb5a6.png";